import { createFileRoute } from "@tanstack/react-router";
import CreateListingAI from "@/pages/dashboard/CreateListingAI";
import PrivateAiPlanGuard from "@/components/private/PrivateAiPlanGuard";

export const Route = createFileRoute("/vinde-masina/ai/")({
  head: () => ({
    meta: [
      { title: "Vinde mașina din video cu AI | RO Auto Market" },
      {
        name: "description",
        content:
          "Filmează mașina 60-90 de secunde, iar AI pregătește fotografiile și datele anunțului. Tu confirmi totul înainte de publicare.",
      },
      { name: "robots", content: "noindex, nofollow" },
      { property: "og:title", content: "Vinde mașina din video cu AI" },
      {
        property: "og:description",
        content: "AI pregătește anunțul din videoclipul tău, iar tu confirmi datele.",
      },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary" },
    ],
  }),
  component: () => (
    <PrivateAiPlanGuard>
      <CreateListingAI sellerType="private" />
    </PrivateAiPlanGuard>
  ),
});
